import { useEffect, useState } from "react";
import { Tokens } from "../../services/SystemNames";
import { hasTokenExpired } from "../helpers/TokenHelpers";

export const useTokenParameter = () => {

    const param = "token";
    const [tokenParameter, setTokenParameter] = useState<string | null>(null);

    useEffect(() => {
        if (!location.search || !location.search.includes(`${param}=`)) return;

        const url = new URL(window.location.href);
        const incomingToken = url.searchParams.get(param);
        const localToken = localStorage.getItem(Tokens.Token);

        if (incomingToken) {
            // remove any existing token from local storage
            if (localToken) {
                localStorage.removeItem(Tokens.Token);
            }
            if (hasTokenExpired(incomingToken)) return;
            setTokenParameter(incomingToken);
            localStorage.setItem(Tokens.Token, incomingToken);
        } else {
            if (localToken) {
                // remove expired token from local storage
                if (hasTokenExpired(localToken)) {
                    localStorage.removeItem(Tokens.Token);
                }
                setTokenParameter(localToken);
            }
        }

    }, [location.search]);

    return tokenParameter;
}
